import FeatureRow from './FeatureRow';

import styles from '../styles/Section.module.css';

const AgentChatsSection = ({ shouldLoad = false }) => {
    return (
        <section className={styles.section}>
            <div className={styles.header}>
                <h2 className={styles.sectionTitle}>AI Agents</h2>
                <p className={styles.sectionSubtitle}>
                    Build, customize, and deploy autonomous agents.
                </p>
            </div>

            <FeatureRow
                title="Create Custom Agents"
                description="Design agents tailored to your specific tasks. Customize their name, logo, description, and welcome message. Define their behavior and knowledge base with a custom prompt."
                videoSrc="https://jetchats.sfo2.cdn.digitaloceanspaces.com/public-videos/demo2/agentblock1"
                shouldLoad={shouldLoad}
            />

            <FeatureRow
                title="Equip with Tools"
                description="Give your agents hands. Add various tools that they can use to perform tasks. You can choose to see the step-by-step execution process or just the final result."
                reversed={true}
                videoSrc="https://jetchats.sfo2.cdn.digitaloceanspaces.com/public-videos/demo2/agentblock2"
                shouldLoad={shouldLoad}
            />

            <FeatureRow
                title="Privacy & Control"
                description="Manage your agents with granular privacy settings. Choose which LLM powers your agent and enable memory for long-term context retention across all dialogues."
                videoSrc="https://jetchats.sfo2.cdn.digitaloceanspaces.com/public-videos/demo2/agentblock3"
                shouldLoad={shouldLoad}
            />

            <FeatureRow
                title="Agent History & Discovery"
                description="Keep track of all your interactions. View your agents, browse their chat history, and explore conversations with public agents created by the community."
                reversed={true}
                videoSrc="https://jetchats.sfo2.cdn.digitaloceanspaces.com/public-videos/demo2/agentblock4"
                shouldLoad={shouldLoad}
            />
        </section>
    );
};

export default AgentChatsSection;
